import api from './api';

export const validateCoupon = async (code, target_id) => {
  const { data } = await api.get('/coupons/verify', {
    params: { code, target_id },
  });

  return data;
};
